import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// REACT_APP_BACKEND_URL must be provided at build time. No hardcoded fallback
// - a stale fallback would silently point production auth calls at the wrong
// domain after a redeploy.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    // Check for stored session
    const storedUser = localStorage.getItem('tasck_user');
    const storedToken = localStorage.getItem('tasck_token');
    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
      setToken(storedToken);
    }
    setLoading(false);
  }, []);

  const login = async (role) => {
    try {
      const response = await axios.post(`${API}/auth/demo-login`, { role });
      const { user: userData, token: userToken } = response.data;
      
      setUser(userData);
      setToken(userToken);
      localStorage.setItem('tasck_user', JSON.stringify(userData));
      localStorage.setItem('tasck_token', userToken);
      
      return userData;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const completeLogin = ({ user: userData, token: userToken }) => {
    setUser(userData);
    setToken(userToken);
    localStorage.setItem('tasck_user', JSON.stringify(userData));
    localStorage.setItem('tasck_token', userToken);
    return userData;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('tasck_user');
    localStorage.removeItem('tasck_token');
  };

  const value = {
    user,
    token,
    loading,
    login,
    completeLogin,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
